/** Chakra recipe registry: single-part recipes and multi-part slot recipes. */
import { accordionSlotRecipe } from './Accordion';
import { alertSlotRecipe } from './Alert';
import { badgeRecipe } from './Badge';
import { breadcrumbSlotRecipe } from './Breadcrumb';
import { buttonRecipe } from './Button';
import { cardSlotRecipe } from './Card';
import { carouselRecipe } from './Carousel';
import { checkboxSlotRecipe } from './Checkbox';
import { containerRecipe } from './Container';
import { dividerRecipe } from './Divider';
import { dragAndDropRecipe, dropZoneRecipe } from './DragAndDrop';
import { drawerSlotRecipe } from './Drawer';
import { fieldSlotRecipe } from './Field';
import { headingRecipe } from './Heading';
import { iconRecipe } from './Icon';
import { inputRecipe } from './Input';
import { linkRecipe } from './Link';
import { listSlotRecipe } from './List';
import { menuSlotRecipe } from './Menu';
import { dialogSlotRecipe } from './Modal';
import { numberInputSlotRecipe } from './NumberInput';
import { popoverSlotRecipe } from './Popover';
import { progressSlotRecipe } from './Progress';
import { radioSlotRecipe } from './Radio';
import { nativeSelectSlotRecipe } from './Select';
import { sliderSlotRecipe } from './Slider';
import { stepsSlotRecipe } from './Steps';
import { switchSlotRecipe } from './Switch';
import { tabsSlotRecipe } from './Tab';
import { tableSlotRecipe } from './Table';
import { tagSlotRecipe } from './Tag';
import { textRecipe } from './Text';
import { textareaRecipe } from './Textarea';
import { tooltipSlotRecipe } from './Tooltip';
import { videoPlayerSlotRecipe } from './VideoPlayer';

export const recipes: Record<string, any> = {
  badge: badgeRecipe,
  button: buttonRecipe,
  carousel: carouselRecipe,
  container: containerRecipe,
  dragAndDrop: dragAndDropRecipe,
  dropZone: dropZoneRecipe,
  heading: headingRecipe,
  icon: iconRecipe,
  input: inputRecipe,
  link: linkRecipe,
  // Chakra names this component Separator.
  separator: dividerRecipe,
  text: textRecipe,
  textarea: textareaRecipe,
};

export const slotRecipes: Record<string, any> = {
  accordion: accordionSlotRecipe,
  alert: alertSlotRecipe,
  breadcrumb: breadcrumbSlotRecipe,
  card: cardSlotRecipe,
  checkbox: checkboxSlotRecipe,
  // Chakra names this component Dialog.
  dialog: dialogSlotRecipe,
  drawer: drawerSlotRecipe,
  field: fieldSlotRecipe,
  menu: menuSlotRecipe,
  nativeSelect: nativeSelectSlotRecipe,
  numberInput: numberInputSlotRecipe,
  popover: popoverSlotRecipe,
  progress: progressSlotRecipe,
  list: listSlotRecipe,
  radioGroup: radioSlotRecipe,
  slider: sliderSlotRecipe,
  steps: stepsSlotRecipe,
  switch: switchSlotRecipe,
  table: tableSlotRecipe,
  tabs: tabsSlotRecipe,
  tag: tagSlotRecipe,
  tooltip: tooltipSlotRecipe,
  // custom (reactifi) component recipes
  videoPlayer: videoPlayerSlotRecipe,
};
